<div class="user-detail">

  <div>

    <div class="label-medium">{{msg.user.roles}}</div>
    <ul>
      @for (role of user.roles; track role.id) {
      <li class="label-small">
        {{role.name}}
      </li>
      }
    </ul>

  </div>

  <div>

    <div class="label-medium">{{msg.user.areas}}</div>
    <ul>
      @for (area of user.areas; track area.id) {
      <li class="label-small">
        {{area.name}}
      </li>
      }
    </ul>

  </div>

  <div>

    <div class="label-medium">{{msg.user.permissions}}</div>
    <ul>
      @for (permission of user.permissions; track permission.id) {
      <li class="label-small">
        {{permission.name}}
      </li>
      }
    </ul>

  </div>

</div>